import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_SETTINGS = {
  company: {
    name: "Onedot 6",
    tagline: "Completing what design begins.",
    phone: "+91 99636 00101",
    email: "hello@onedot6.com",
    address: "Experience Center · By Appointment · India",
    hours: "By appointment · Monday to Saturday, 10 AM – 7 PM",
  },
  socials: {
    whatsapp_number: "919963600101",
    whatsapp_display: "+91 99636 00101",
    instagram_handle: "onedot6",
    instagram_url: "https://instagram.com/onedot6",
    linkedin_url: "https://www.linkedin.com/company/onedot6/?viewAsMember=true",
  },
  branding: {
    logo_url: "",
    logo_light_url: "",
    favicon_url: "",
    og_image_url: "",
  },
  seo: {
    site_name: "Onedot6",
    site_url: "https://onedot6.com",
    default_title: "Onedot6 — Completing what design begins.",
    title_suffix: " · Onedot6",
    default_description:
      "Onedot6 is a design-completion and curation studio by UNA.6. We refine, curate and complete residential and commercial spaces.",
    default_og_image_url: "",
    robots_index: true,
    robots_extra_disallow: [],
  },
};

const SettingsCtx = createContext({ settings: DEFAULT_SETTINGS, ready: false, refresh: async () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const s = await api.getSettings();
      setSettings({
        company: { ...DEFAULT_SETTINGS.company, ...(s.company || {}) },
        socials: { ...DEFAULT_SETTINGS.socials, ...(s.socials || {}) },
        branding: { ...DEFAULT_SETTINGS.branding, ...(s.branding || {}) },
        seo: { ...DEFAULT_SETTINGS.seo, ...(s.seo || {}) },
        updated_at: s.updated_at,
      });
    } catch (err) {
      console.warn("Settings load failed; using defaults", err);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ settings, ready, refresh }), [settings, ready, refresh]);
  return <SettingsCtx.Provider value={value}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  return useContext(SettingsCtx);
}

export const DEFAULT_SITE_SETTINGS = DEFAULT_SETTINGS;
